@if (featureToggle.isEligible) {
  <div class="ft-panel">
    <button class="ft-panel__trigger" (click)="toggle()" [title]="'featureToggle.title' | translate">
      <i class="fa-solid fa-flask-vial"></i>
    </button>

    @if (isOpen()) {
      <div class="ft-panel__popup">
        <div class="ft-panel__popup-title">{{ 'featureToggle.title' | translate }}</div>

        <label class="ft-panel__item">
          <span>{{ 'featureToggle.contractRequests' | translate }}</span>
          <input
            type="checkbox"
            [checked]="featureToggle.contractRequestsEnabled()"
            (change)="featureToggle.toggleContractRequests()"
          />
        </label>

        <label class="ft-panel__item">
          <span>{{ 'featureToggle.pricing' | translate }}</span>
          <input
            type="checkbox"
            [checked]="featureToggle.pricingEnabled()"
            (change)="featureToggle.togglePricing()"
          />
        </label>

        <label class="ft-panel__item">
          <span>{{ 'featureToggle.ewonStationConfig' | translate }}</span>
          <input
            type="checkbox"
            [checked]="featureToggle.ewonStationConfigEnabled()"
            (change)="featureToggle.toggleEwonStationConfig()"
          />
        </label>
      </div>
    }
  </div>
}
